import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCardFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.cardGap = section.data.cardGap * 4;
    this.cardCount = section.data.cardCount;

    let breakpoints = {};

    if (this.cardCount > 3) {
      breakpoints = {
        [unitlessBreakpoints.sm]: {
          perPage: 2,
        },
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          destroy: true,
        },
      };
    } else {
      breakpoints = {
        [unitlessBreakpoints.sm]: {
          perPage: 2,
        },
        [unitlessBreakpoints.md]: {
          destroy: true,
        },
      };
    }

    initCarousel(this.el, {
      perPage: 1,
      gap: this.cardGap,
      pagination: false,
      breakpoints,
    });
  }
}
